<div class="page-title-area">
    <img src="assets/images/purchase-program.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Tailored Apple Purchase Programs</h2>
            <!-- <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Case Studies Details</li>
            </ul> -->
        </div>
    </div>

   <!--  <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <!-- <div class="row">
            <div class="col-12">
                <div class="services-img mb">
                    <img src="assets/images/case-details/1.jpg" alt="Image">
                </div>
            </div>

            <div class="col-12">
                <div class="services-details-text">
                    <h2>Joe’s Company Software Development Case</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum  not only five centuries, but also the leap into.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a dictionary of over 200 Latin words, combined with a</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc generators on the Internet tend to repeat predefined chunks as necessary, making this the first generator dictionary of over 200 Latin words, combined with a.</p>
                </div>
            </div>
        </div> -->
        <!-- <div class="section-title">
            <div style="display: flex; flex-direction: row; text-align: center; justify-content: center;">
            <div><a href="https://www.jainuniversity.ac.in/" target="_blank"><h2> Jain University  &nbsp;</h2></a></div>
            <div style="margin-top: 4px;">
                <a href="https://www.jainuniversity.ac.in/" target="_blank"><span class="material-symbols-outlined" style="font-size: 35px; font-weight: 600;">
                    arrow_outward
                    </span></a>
            </div>
            </div>
        </div> -->

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/WhatsApp Image 2025-04-24 at 12.50.35.jpeg" alt="Person"  style="border-radius: 15px; background-color: #8080803b;">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>Tailored Apple Purchase Programs</h3>
                    <p>The Apple Buy Back Programme offers an opportunity to exchange your old Apple devices for new ones, complete with comprehensive support options. This includes Apple Care+ for enhanced coverage and technical support, as well as Apple Enterprise Support for business solutions. Welcome to Our Purchase Programs for Apple Developers!
                        Are you new to Mac or looking to enhance your skills as a developer? Our tailored purchase programs are designed to cater to both beginners and seasoned professionals in the Apple development ecosystem.
                        </p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h5>Developer Purchase Program</h5>        
                    <p>Join the Developer Purchase Program to gain access to the latest tools, resources, and support. Whether you are developing apps for iOS, macOS, watchOS, or tvOS, our program provides the essential resources needed to build, test, and distribute your apps efficiently.</p>
                    <p>As a member, you will benefit from advanced app capabilities, extensive beta testing tools, and access to app analytics. Enrol today to transform your ideas into reality and reach millions of users worldwide.</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/apple_device_trade.jpg" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/newtomac.png" alt="Person" style="border-radius: 15px; background-color: #8080803b;"> 
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h5>New to Mac? </h5>        
                    <p>Don't worry if you are new to Mac; we offer a comprehensive introduction to using and developing on macOS. Our resources will guide you through the transition and help you get the most out of your Mac device. From basic navigation tips to understanding advanced Mac features, we’ve got you covered.</p>
                    <p>Explore our purchase programs today and embark on your journey to becoming a successful Apple developer. Unlock the potential of your ideas with the support and resources tailored just for you.</p>
                    <p>For more information or to enrol, please visit our website or contact our support team. We’re here to help you succeed in your development journey!</p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <!-- <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h5></h5>        
                </div>

                <div class="col-lg-6">
                    <div class="services-img mb-qc">
                        <img src="assets/images/solutions-details/5.png" alt="Image">
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="services-img mb-qc">
                        <img src="assets/images/solutions-details/5.png" alt="Image">
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>Conclusion</h3>
                    <p>The successful installation and configuration of the Apple Lab's iMacs at JAIN (Deemed-to-be University) have significantly enhanced the learning environment, positioning the university as a leader in integrating technology into education.</p>
                </div>
            </div>
        </div> -->
        
        <!-- <div class="scrives-item-3 mt-4">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <h3>Conclusion</h3>
                    <p>Essilor’s adoption of iPads highlights the importance of digital tools in modernising sales operations, ultimately enhancing customer engagement and business outcomes.</p>   
                </div>
            </div>
        </div> -->
    </div>
</section>